import ol from 'ol';

export default function getUid(feature) {
	return ol.getUid(feature).toString();
}
